import script from "./app-main.vue?vue&type=script&setup=true&lang=js"
export * from "./app-main.vue?vue&type=script&setup=true&lang=js"

import "./app-main.vue?vue&type=style&index=0&id=31451023&lang=scss&scoped=true"

import exportComponent from "/Users/tyk/Desktop/work/kangleiot/biz-sharingspace/sharing-space-admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31451023"]])

export default __exports__